import { C_HTTP_STATUS } from '_acaSrc/utility/constants';
import { getWindow } from '_acaSrc/utility/DOM';
import { JL } from 'jsnlog';
import utdRest from '_acaSrc/utility/http/UtdRestHooks';

export const initErrorState = () => {
    return {
        code: 0,
        title: '',
        message: '',
        clearSearch: false,
        params: {}
    };
};

const initSecurityAgentParams = () => {
    return {
        securityAgentName: '',
        sessionId: '',
        issuedDateTimestamp: null,
        systemDateTimestamp: null
    };
};

const state = {
    errorClass: false,
    error: initErrorState(),
    errorLoading: false,
    securityAgentParams: initSecurityAgentParams()
};

export const getters = {
    errorClass: state => state.errorClass,
    errorTitle: state => state.error.title,
    errorMessage: state => state.error.message,
    errorParams: state => state.error.params,
    errorClearSearch: state => state.error.clearSearch,
    isUnspecifiedError: (state, getters) => {
        return (!state.error.message || state.error.code === C_HTTP_STATUS.SERVER_ERROR)
            && !state.errorLoading && !getters.isSecurityAgentError;
    },
    errorLoading: state => state.errorLoading,
    isSecurityAgentError: state => {
        return state.securityAgentParams.securityAgentName && state.securityAgentParams.sessionId;
    },
    securityAgentParams: state => {
        return state.securityAgentParams;
    }
};

export const SET_ERROR_CLASS = 'SET_ERROR_CLASS';
export const SET_ERROR_CODE = 'SET_ERROR_CODE';
export const SET_ERROR_TITLE = 'SET_ERROR_TITLE';
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const SET_ERROR_PARAMS = 'SET_ERROR_PARAMS';
export const SET_ERROR_CLEARSEARCH = 'SET_ERROR_CLEARSEARCH';
export const RESET_ERROR = 'RESET_ERROR';
export const SET_ERROR_LOADING = 'SET_ERROR_LOADING';
export const SET_SECURITY_AGENT_NAME = 'SET_SECURITY_AGENT_NAME';
export const SET_SECURITY_AGENT_SESSION_ID = 'SET_SECURITY_AGENT_SESSION_ID';
export const SET_SECURITY_AGENT_ISSUED_DATE = 'SET_SECURITY_AGENT_ISSUED_DATE';
export const SET_SECURITY_AGENT_SYSTEM_DATE = 'SET_SECURITY_AGENT_SYSTEM_DATE';

export const mutations = {
    [SET_ERROR_CLASS]: (state, errorClass) => state.errorClass = errorClass,
    [SET_ERROR_CODE]: (state, code) => state.error.code = code,
    [SET_ERROR_TITLE]: (state, title) => state.error.title = title,
    [SET_ERROR_MESSAGE]: (state, msg) => state.error.message = msg,
    [SET_ERROR_PARAMS]: (state, params) => state.error.params = params,
    [SET_ERROR_CLEARSEARCH]: (state, value) => state.error.clearSearch = value,
    [RESET_ERROR]: state => state.error = initErrorState(),
    [SET_ERROR_LOADING]: (state, value) => state.errorLoading = value,
    [SET_SECURITY_AGENT_NAME]: (state, value) =>
        state.securityAgentParams.securityAgentName = value,
    [SET_SECURITY_AGENT_SESSION_ID]: (state, value) => state.securityAgentParams.sessionId = value,
    [SET_SECURITY_AGENT_ISSUED_DATE]: (state, value) =>
        state.securityAgentParams.issuedDateTimestamp = value,
    [SET_SECURITY_AGENT_SYSTEM_DATE]: (state, value) =>
        state.securityAgentParams.systemDateTimestamp = value
};

export const actions = {
    resolveContent403({ commit }, error) {
        let isHasError = true;
        try {
            switch (error.data.errors[0].utdStatus) {      
            case 'REQUESTS_PER_SEARCH_LIMIT':
                // Redirect to search page
                isHasError = false;
                commit(SET_ERROR_CLEARSEARCH, true);
                getWindow().location.href = '/contents/search';
                break;

            case 'ANON_REQUESTS_PER_TIMESPAN_LIMIT_WITHOUT_CAPTCHA':
                isHasError = false;
                getWindow().location.href = '/login?captcha=true';
                break;

            case 'REQUESTS_PER_SESSION_LIMIT':
                // eslint-disable-next-line no-var
                var errorMessage = error.data.errors[0].message;
                JL('Angular.Ajax').fatalException({
                    errorMessage,
                    status: error.status,
                    config: error.config
                });

                commit(SET_ERROR_CLASS, true);
                commit(SET_ERROR_MESSAGE, errorMessage);
                getWindow().location.replace('/view-error');
                break;

            default:
                isHasError = false;
                getWindow().location.href = '/content-not-available';
                break;
            }
        }
        catch {
            isHasError = false;
            getWindow().location.href = '/content-not-available';
        }
        return isHasError;
    },
    async setEmrLoginErrorMessage({ commit }) {
        commit(SET_ERROR_LOADING, true);
        try {
            const data = await utdRest('emr/login-error-message');
            if (data.emrLoginErrorMessage) {
                commit(SET_ERROR_MESSAGE, data.emrLoginErrorMessage);
                commit(SET_ERROR_CLASS, true);
            }
            else {
                getWindow().location.href = '/error';
            }
        }
        catch {
            getWindow().location.href = '/error';
        }
        commit(SET_ERROR_LOADING, false);
    },
    setSecurityAgentParams({ commit }, params) {
        if (!params.securityAgentName || !params.sessionId) {
            getWindow().location.href = '/error';
        }
        commit(SET_SECURITY_AGENT_NAME, params.securityAgentName);
        commit(SET_SECURITY_AGENT_SESSION_ID, params.sessionId);
        const issuedDateTimestamp = parseInt(params.issuedDate);
        const systemDateTimestamp = parseInt(params.systemDate);
        if (issuedDateTimestamp && systemDateTimestamp) {
            commit(SET_SECURITY_AGENT_ISSUED_DATE, issuedDateTimestamp);
            commit(SET_SECURITY_AGENT_SYSTEM_DATE, systemDateTimestamp);
        }
    }
};

const error = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};

export default error;
